import { useQuery } from "@apollo/client";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Radio, Select } from "@aqar-app/react-ui";
import { Icon } from "@/components/icon";
import css from "../.module.scss";
import { GET_RED_CITIES } from "@/graphql/queries/regions";
import styles from "../../../containers/layouts/searchbar/searchbar.module.scss";
import { usePath } from "@/contexts/path/path";
import { FiltersUi } from "../controls";
import { appHistory, appLocation } from "@/lib/app.history";
import { useRouter } from "next/router";
import { MainTabs } from "@/components/filters/filters";

const RedCategories = [
  {
    id: 6,
    ga_listing_type: "sale",
    ga_property_category: "apartment",
    is_rent: false,
    name: "شقة للبيع",
    en: "Apartment for sale",
    plural: "شقق للبيع",
    uri: "شقق-للبيع",
    path: "/شقق-للبيع",
    keywords: ["شقة", "شقق", "للبيع"],
    description:
      "تصفح آلاف عروض الشقق للبيع في جميع مدن ومناطق السعودية بأسعار ومساحات مناسبة بالصور والتفاصيل. مع الاطلاع على ميزة تقييم الحي في تطبيق عقار ، تطبيق عقار",
  },
  {
    id: 3,
    ga_listing_type: "sale",
    ga_property_category: "villa",
    is_rent: false,
    name: "فيلا للبيع",
    en: "Villa for sale",
    plural: "فلل للبيع",
    uri: "فلل-للبيع",
    path: "/فلل-للبيع",
    keywords: ["فيلا", "دوبلكس", "دبلكس", "دوبلكسات", "فلل", "للبيع"],
    description:
      "أفضل إعلانات الفلل للبيع في جميع مدن ومناطق السعودية بالصور، تواصل مع المالك مباشرة أو المكتب و اعرف تفاصيل الحي مع خدمة تقييم الأحياء على تطبيق عقار ، تطبيق عقار",
  },
  {
    id: 22,
    ga_listing_type: "sale",
    ga_property_category: "floor",
    is_rent: false,
    name: "دور للبيع",
    en: "Floor for sale",
    plural: "دور للبيع",
    uri: "دور-للبيع",
    path: "/دور-للبيع",
    keywords: [
      "دور للبيع",
      "ادوار للبيع",
      "دور ارضي للبيع",
      "بيت دور للبيع",
      "ادوار تمليك",
    ],
    description:
      "أدوار للبيع بأحياء الرياض و جدة و مكة والدمام و الخبر وجميع مدن ومناطق السعودية، يمكنك البحث عن دور أرضي أو أول أو ثاني بأسعار مناسبة على عقار ، تطبيق عقار",
  },
];
export function RedFilters({ setOpened, opened } = {}) {
  const { categories } = usePath();
  const {
    filters: redFilters,
    searchFields,
    resetFilters,
    updateContext,
    city: activeCity,
    category,
    setFilters,
  } = usePath();

  const Fields = useMemo(
    () => searchFields?.map((field) => [FiltersUi[field.type], field]) || [],
    [category, searchFields],
  );
  const { data: { RealEstateProjects: { cities = [] } = {} } = {} } =
    useQuery(GET_RED_CITIES);

  useEffect(() => {
    if (opened) {
      document.body.style.height = "100vh";
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.height = "auto";
      document.body.style.overflow = "unset";
    };
  }, [opened]);

  return (
    <div className={css.filters}>
      <div className={css.header}>
        <Icon
          width={25}
          height={25}
          onClick={() => {
            appHistory.pushState({}, "", appLocation.href?.split("#")[0] || "");
            setOpened(false);
          }}
          className={css.headerIcon}
          name="OutlinedClose"
        />
        <div className={styles.title}>ابحث عن عقار</div>
        <Icon
          width={25}
          height={25}
          className={css.headerIcon}
          name="reload"
          onClick={() => {
            resetFilters();
          }}
        />
      </div>

      <div className={css.body}>
        <div>
          <h3>المدينة</h3>
          <Select
            onSelect={(id, event) => {
              const di = event.raw;
              if (!di) return;
              updateContext({
                city: di,
              });
            }}
            value={activeCity?.city_id}
            searchable
          >
            <Select.Option>
              <p>غير محدد</p>
            </Select.Option>
            {cities?.map((ct) => (
              <Select.Option raw={ct} key={ct.city_id} value={ct.city_id}>
                <p>{ct.name}</p>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          <h3>الفئة</h3>
          <Radio
            name="category"
            button
            onChange={(event, raw) => {
              updateContext({
                category: raw,
                filters: {
                  ...resetFilters,
                  category: {
                    eq: raw?.id,
                  },
                },
              });
            }}
            onReselect={() => {
              updateContext({
                filters: {
                  ...resetFilters,
                  category: undefined,
                },
              });
            }}
            searchable
            value={redFilters?.category?.eq || 0}
          >
            {RedCategories?.map((cat) => (
              <Radio.Option
                raw={cat}
                key={cat.id}
                value={cat.id}
                label={cat.name}
              />
            ))}
          </Radio>
        </div>

        {Fields.map(([Component, props]) => (
          <Component
            key={props.name}
            {...props}
            value={
              redFilters?.[props?.name]?.[props?.operation] ||
              redFilters?.[props?.name]
            }
            onChange={(name, filter) => {
              setFilters({ [name]: filter });
            }}
          />
        ))}
      </div>
      <div className={css.search}>
        <Button theme="primary">بحث</Button>
      </div>
    </div>
  );
}

RedFilters.Layout = function Layout({ children } = {}) {
  const [opened, setOpened] = useState(false);
  const router = useRouter();
  const { listing, basePath, updateContext } = usePath();

  useEffect(() => {
    function open() {
      setOpened(true);
    }

    document.addEventListener("opensearchbar", open);

    return () => {
      document.removeEventListener("opensearchbar", open);
    };
  }, [opened]);

  useEffect(() => {
    if (appLocation.hash === "#filters") setOpened(true);
  }, []);

  useEffect(() => {
    const onpopstate = () => {
      /*
       * When user clicks back we will query localStorage for the resolvedPath
       * */
      if (appLocation.hash !== "#filters" && opened) setOpened(false);

      if (appLocation.hash === "#filters" && !opened) setOpened(true);
    };
    window.addEventListener("popstate", onpopstate);

    return () => window.removeEventListener("popstate", onpopstate);
  }, [opened]);

  return (
    <div>
      {opened && (
        <div className={css.sidebar}>
          <div
            onClick={() => {
              router.push(
                appLocation.pathname +
                  "" +
                  decodeURIComponent(appLocation.search),
              );
              setOpened(false);
            }}
            className={css.outsidesidebar}
          />
          <RedFilters setOpened={setOpened} opened={opened} />
        </div>
      )}
      <div className={css.root}>
        <div
          className={`${css.listingsRoot} ${listing ? css.white : ""} ${
            !listing && css.list
          }`}
        >
          <MainTabs />

          {children}
        </div>
      </div>
    </div>
  );
};
export default RedFilters;
